import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { BASE_API_MDM } from "../../../config";

// Mở nhãn dán hàng GHTK (file PDF do GHTK dựng sẵn) ở tab mới để in.
// code: mã đơn hàng hoặc mã phiếu điều chuyển đã đẩy sang GHTK; mã vận đơn và token server tự xác định
export const printGhtkLabel = async (code: string) => {
  // Mở tab ngay lúc bấm nút: chờ API trả về rồi mới mở thì trình duyệt chặn popup
  const tab = window.open("", "_blank");

  try {
    const params = new URLSearchParams({ code, original: "portrait" });
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${BASE_API_MDM}/api/v1/GHTK/print-label?${params.toString()}`,
      {
        headers: { Authorization: `Bearer ${token?.replace(/"/g, "")}` },
      },
    );

    // Chỉ coi là thành công khi nhận đúng file PDF: lỗi server trả về dạng
    // { success: false, message } (lỗi GHTK giữ nguyên câu GHTK trả), có khi kèm HTTP 200
    const contentType = response.headers.get("content-type") ?? "";
    if (!response.ok || !contentType.includes("application/pdf")) {
      const error = await response.json().catch(() => null);
      throw new Error(
        error?.errors?.msg?.[0] ||
          error?.message ||
          `In nhãn GHTK thất bại (HTTP ${response.status}) !`,
      );
    }

    const blobUrl = URL.createObjectURL(await response.blob());
    if (tab) tab.location.href = blobUrl;
    else window.open(blobUrl, "_blank");
  } catch (error: any) {
    tab?.close();
    NotificationExtension.Fails(error?.message || "In nhãn GHTK thất bại !");
  }
};
